/**
 * CZNA-972 — lazy count of the proposals and records waiting on the caller.
 *
 * <p>CZNA-1446: it counts the Inbox (`/review-queue/returned` — returned to me plus mine to
 * review), the one place a user acts from; the administrator's whole review is not a count
 * of work waiting on them.
 *
 * <p>Cheap query: asks the endpoint for {@code limit=1} and reads
 * {@code totalRecords} only — the row payload is irrelevant here.
 *
 * <p>CZNA-554: the one row it does get is the <em>newest</em> waiting item (`DESC`), so the
 * same request also answers "has anything arrived since I last looked" — see
 * `utils/reviewQueueLastSeen`. The total is independent of the order.
 *
 * <p>The query key is intentionally prefixed with `review-queue` so that
 * `useReviewMutation`'s `invalidateQueries(['review-queue'])` (react-query
 * matches by key prefix) also refreshes this count after an approve / redirect
 * / delete action — no extra wiring needed.
 *
 * <p>`enabled` gates the fetch: when the caller passes `enabled = false`
 * (no signed-in user yet) the request is never sent.
 */
import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchReturnedQueue } from '../api/reviewQueueService';
export var REVIEW_QUEUE_COUNT_KEY = ['review-queue', 'count'];
export var useReviewQueueCount = function (enabled) {
    var _a, _b, _c, _d;
    var ky = useOkapiKy();
    var _e = useQuery(REVIEW_QUEUE_COUNT_KEY, function () {
        return fetchReturnedQueue(ky, {
            offset: 0,
            limit: 1,
            sortBy: 'WAITING_SINCE',
            sortOrder: 'DESC',
        });
    }, { enabled: enabled }), data = _e.data, isLoading = _e.isLoading;
    return {
        count: (_a = data === null || data === void 0 ? void 0 : data.totalRecords) !== null && _a !== void 0 ? _a : 0,
        newestWaitingSince: (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.waitingSince) !== null && _d !== void 0 ? _d : null,
        isLoading: isLoading,
    };
};
export default useReviewQueueCount;
